const doc = [({"zh_cn":({"adminConstantPromotionType":({"consecutiveStay":"连续住宿折扣", "goto":"去旅行", "member":"会员折扣", "official":"官网限时优惠", "promotionCode":"输入代码"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;